/**
 * Where Fonctionnalités and Règles are, from the URL hash, so a selection is
 * a link that can be shared: `#features` is the list, `#features/<settingId>`
 * one feature and its exceptions; `#rules` and `#rules/<ruleId>` likewise.
 */

export type ConfigScreen = "features" | "rules";

/** The id selected after `#<screen>/`, or null for the bare list. */
export function selectedId(hash: string, screen: ConfigScreen): string | null {
  const rest = hash.replace(/^#\/?/, "");
  if (rest !== screen && !rest.startsWith(`${screen}/`) && !rest.startsWith(`${screen}?`)) return null;
  const id = decodeURIComponent(rest.slice(screen.length).replace(/^\/+/, "").split(/[/?]/)[0] ?? "").trim();
  return id || null;
}

export function configHref(screen: ConfigScreen, id?: string | null): string {
  return id ? `#${screen}/${encodeURIComponent(id)}` : `#${screen}`;
}
